import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ProfileImage = ({ name }) => {
  const [initials, setInitials] = useState('');

  useEffect(() => {
    if (!name) return;
    const nameSplits = name.split(' ');
    let initialCharacters = nameSplits[0].charAt(0);
    if (nameSplits.length > 1) {
      initialCharacters += nameSplits[nameSplits.length - 1].charAt(0);
    }
    setInitials(initialCharacters);
  }, [name]);

  return <ProfileImage.Wrapper>{initials}</ProfileImage.Wrapper>;
};

export default ProfileImage;

ProfileImage.Wrapper = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgb(0, 200, 255);
  font-size: 4rem;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
